<template>
  <div class="p-8 h-full">
    <div class="max-w-xl mx-auto bg-white rounded-lg shadow-md overflow-hidden">
      <div class="px-6 py-4 border-b relative">
        <div v-if="roleName === 'manager'" class="absolute left-6 top-1/2 transform -translate-y-1/2 text-xs text-gray-600">
          <p class="mb-1">
            Jetons restants : <strong>{{ jetonsRestants || 0 }}</strong>
          </p>
          <p>Jetons consommés : <strong>{{ usedJetons || 0 }}</strong></p>
        </div>
        <h2 class="text-2xl font-bold text-gray-800 text-center">
          Profil
        </h2>
      </div>
      <div class="p-6">
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">Nom</label>
          <input
            v-model="firstname"
            type="text"
            class="block border border-grey-light w-full p-3 rounded"
            name="Nom"
            placeholder="Nom"
          >
        </div>
        
        <div class="mb-6">
          <label class="block text-gray-700 text-sm font-bold mb-2">Prénom</label>
          <input
            v-model="lastname"
            type="text"
            class="block border border-grey-light w-full p-3 rounded"
            name="prenom"
            placeholder="Prénom"
          >
        </div>
        
        <div class="mb-6">
          <label class="block text-gray-700 text-sm font-bold mb-2">Adresse Email</label>
          <input
            v-model="email"
            type="text"
            class="block border border-grey-light w-full p-3 rounded"
            name="email"
            placeholder="Email"
          >
        </div>

        <label v-if="roleName === 'supervisor' || roleName === 'manager'" class="flex items-center mb-4">
          <t-checkbox v-model="notifyOnProjectUpload" name="chks_email_upload" />
          <span class="ml-2 text-sm">Recevoir un email à l'arrivée d'un projet</span>
        </label>

        <label class="flex items-center mb-6">
          <t-checkbox v-model="changepassword" name="chks_password" />
          <span class="ml-2 text-sm font-semibold text-gray-700">Changer le mot de passe ?</span>
        </label>

        <div :class="[changepassword ? 'block' : 'hidden']" class="bg-gray-50 p-4 rounded-lg mb-6 border border-gray-200">
          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">Ancien mot de passe</label>
            <input
              v-model="password"
              type="password"
              class="block border border-grey-light w-full p-3 rounded"
              name="password"
              placeholder="Ancien Mot de passe"
            >
          </div>

          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">Nouveau mot de passe</label>
            <input
              v-model="password1"
              type="password"
              class="block border border-grey-light w-full p-3 rounded"
              name="password"
              placeholder="Mot de passe"
            >
          </div>

          <div>
            <label class="block text-gray-700 text-sm font-bold mb-2">Confirmer le nouveau mot de passe</label>
            <input
              v-model="password2"
              type="password"
              class="border border-grey-light w-full p-3 rounded"
              name="confirm_password"
              placeholder="Confirmer Mot de passe"
            >
          </div>
        </div>

        <button
          class="w-full text-center py-3 rounded bg-raphal-total text-white hover:bg-raphal-termine focus:outline-none my-1 font-bold transition duration-150"
          @click="UpdateProfile"
        >
          Enregistrer les modifications
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import { mapGetters } from 'vuex';

import { Toast } from '../toast';

export default {
  name: 'ProfileView',
  data() {
    return {
      firstname: null,
      lastname: null,
      email: null,
      password: null,
      password1: null,
      password2: null,
      changepassword: false,
      notifyOnProjectUpload: false,
      jetonsRestants: 0,
      usedJetons: 0
    };
  },
  computed: {
    ...mapGetters({
      user: 'Auth/user',
      roleName: 'Auth/roleUser'
    })
  },
  watch: {
    user: {
      immediate: true,
      handler(newUser) {
        if (newUser) {
          this.firstname = newUser.firstName;
          this.lastname = newUser.lastName;
          this.email = newUser.email;
          this.notifyOnProjectUpload = newUser.notifyOnProjectUpload;
          this.jetonsRestants = newUser.jetonsRestants;
          this.usedJetons = newUser.usedJetons;
        }
      }
    }
  },
  methods: {
    UpdateProfile: function () {
      if (this.changepassword) {
        if (!this.password1 || this.password1.length < 8) {
          Toast.fire({
            icon: 'error',
            title: 'Veuillez spécifier un mot de passe d\'au moins 8 caractères.'
          });
          return;
        }
        if (this.password1 !== this.password2) {
          Toast.fire({
            icon: 'error',
            title: 'Les mots de passe ne correspondent pas.'
          });
          return;
        }
      }

      let query = gql`
        mutation updateProfile(
          $firstname: String!
          $lastname: String!
          $email: String!
          $password: String
          $password1: String
          $password2: String
          $changePassword: Boolean!
          $notifyOnProjectUpload: Boolean
        ) {
          updateProfile(
            firstname: $firstname
            lastname: $lastname
            email: $email
            password: $password
            password1: $password1
            password2: $password2
            changePassword: $changePassword
            notifyOnProjectUpload: $notifyOnProjectUpload
          ) {
            success
            errors
          }
        }
      `;

      this.$apollo
        .mutate({
          mutation: query,
          variables: {
            firstname: this.firstname,
            lastname: this.lastname,
            email: this.email,
            password: this.password,
            password1: this.password1,
            password2: this.password2,
            changePassword: this.changepassword,
            notifyOnProjectUpload: this.notifyOnProjectUpload
          }
        })
        .then((data) => {
          if (data.data.updateProfile) {
            if (data.data.updateProfile.success == true) {
              Toast.fire({
                icon: 'success',
                title: 'Opération effectuée avec succès !'
              });
              
              this.$store.dispatch('Auth/getAuthUser');
              
              this.password = null;
              this.password1 = null;
              this.password2 = null;
              this.changepassword = false;

              if (window.history.length > 2) {
                this.$router.back();
              } else {
                this.$router.push('/');
              }
            } else {
              const errorMsg = data.data.updateProfile.errors && data.data.updateProfile.errors.length > 0
                ? JSON.parse(data.data.updateProfile.errors[0]).message
                : 'Une erreur est survenue lors de la mise à jour.';

              Toast.fire({
                icon: 'error',
                title: errorMsg
              });
            }
          } else {
            Toast.fire({
              icon: 'error',
              title: 'Erreur !'
            });
          }
        })
        .catch((error) => {
          this.$log.error("UpdateProfile failed", error);
          Toast.fire({
            icon: 'error',
            title: 'Une erreur inattendue est survenue.'
          });
        });
    }
  }
};
</script>
